module.exports = __webpack_public_path__ + "media/images/logo_mobile-8f2dc8e6df80b7cf4824a3c05ac48603.png";